import { mobileShopApi } from '../mobileShopApi';
import { MasterRow, PagedResponse } from '../../types/master';
import { Purchase } from '../../types/purchase';

export const purchaseApi = mobileShopApi.injectEndpoints({
  endpoints: (builder) => ({
    getPurchasePage: builder.mutation<PagedResponse<MasterRow>, { searchValue: string; page: number; size: number }>({
      query: ({ searchValue, page, size }) => ({
        url: `/purchase/search-by-criteria/page=${page}/size=${size}`,
        method: 'POST',
        body: { searchValue },
      }),
    }),

    getPurchaseById: builder.query<Purchase, number>({
      query: (id) => `/purchase/${id}`,
      providesTags: ['Purchase'],
    }),

    savePurchase: builder.mutation<Purchase, Purchase>({
      query: (body) => ({ url: '/purchase', method: 'POST', body }),
      invalidatesTags: ['Purchase', 'Imei', 'Product', 'Batch'],
    }),

    deletePurchase: builder.mutation<void, number>({
      query: (id) => ({ url: `/purchase/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Purchase', 'Imei', 'Product', 'Batch'],
    }),

    /** Asked while the shop is still typing, so a clash shows up before they save. */
    checkDuplicateImei: builder.mutation<{ duplicates: string[] }, string[]>({
      query: (imeiNumbers) => ({ url: '/purchase/duplicate-imei', method: 'POST', body: { imeiNumbers } }),
    }),

  }),
});

export const {
  useGetPurchasePageMutation,
  useLazyGetPurchaseByIdQuery,
  useSavePurchaseMutation,
  useDeletePurchaseMutation,
  useCheckDuplicateImeiMutation,
} = purchaseApi;
